import crawling from './images/crawling.png'
import manufacture from './images/manufacture.png'
import database from './images/database.png'
import showdata from './images/showdata.png'
import custom from './images/custom.png'

export const titleItems = {
   title: '빅데이터 솔루션',
   subTitle: '일반 데이터 가공',
}

export const navItems = [
   {
      title: '데이터 크롤링',
      label: '웹 데이터를 추출, 분류된 데이터셋을 API, CSV등의 다양한 형태로 전달해드립니다.',
      img: crawling,
   },
   {
      title: '데이터 전처리',
      label: '무작위한 데이터를 일관하게 정제/데이터 가공 및 분석 활용성을 높여드립니다.',
      img: manufacture,
   },
   {
      title: '데이터 베이스 구축',
      label: '데이터 베이스 용도에 알맞게 구축하고 안전하고 효율적으로 관리할 수 있도록 합니다.',
      img: database,
   },
   {
      title: '데이터 시각화',
      label: '데이터 분석결과를 쉽게 이해하도록 시각적으로 표현하여 정보를 명확하고 효과적으로 전달합니다.',
      img: showdata,
   },
   {
      title: '커스텀 개발',
      label: '고객님들이 의뢰하는 프로젝트에 필요한 서비스 및 기능을 개발하여 결과물을 제공합니다.',
      img: custom,
   },
]